// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TEGG9","spinner":"styles_spinner__BoWuX","ring":"styles_ring__bDc5H"};